import React from 'react';
import './Spinner.css';

const Spinner = ({ 
  size = 'medium',
  className = '',
  ...props 
}) => {
  const baseClasses = 'spinner';
  const sizeClasses = `spinner-${size}`;
  
  const classes = [baseClasses, sizeClasses, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...props} />
  );
};

export default Spinner;



